/* eslint-disable import/no-unresolved */
/* eslint-disable func-names */
/* eslint-disable no-plusplus */
const focusHelper = require('base/components/focus');
const lozad = require('lozad');
const base = require('../product/base');
const slickSlider = require('../components/slider');
const constants = require('../constants');
const utils = require('../utils');

/**
 * Trigger lozad
 */
function triggerLozad() {
    const observer = lozad();
    observer.observe();
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    let newUrl = url;
    newUrl
        += (newUrl.indexOf('?') !== -1 ? '&' : '?')
        + Object.keys(params)
            .map(key => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');

    return newUrl;
}

const updateMiniCartCountClass = (count, miniCartCount) => {
    if (miniCartCount.length) {
        const countParsed = parseInt(count, 10);
        miniCartCount.each((index, node) => {
            const miniCartCountNode = $(node);
            // eslint-disable-next-line no-restricted-globals
            if (countParsed === 0 || isNaN(countParsed)) {
                miniCartCountNode.addClass('no-items');
            } else {
                miniCartCountNode.removeClass('no-items');
            }
        });
    }
};

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            const errorHtml = `${'<div class="alert alert-danger alert-dismissible valid-cart-error '
                + 'fade show" role="alert">'
                + `<button type="button" class="close no-btn" data-dismiss="alert" aria-label="${utils.getCloseLabel()}">`
                + '<span class="icon-cross-line"></span>'
                + '</button>'}${data.valid.message}</div>`;

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append(`${'<div class="row"> '
                + '<div class="col-12 empty-minicart text-center"> '
                + ''}${data.resources.emptyCartMsg} `
                + '</div> '
                + '</div>');
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            updateMiniCartCountClass(data.numItems, $('.minicart-quantity'));
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems,
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

function updateMiniCart(numItems) {
    const cartIcon = $('.cart-icon-container:not(.sidebar-minicart-total)');
    const url = cartIcon.data('minicart');
    const minicart = $('.minicart-container');
    const overlay = $('body > .overlay');

    // eslint-disable-next-line no-shadow
    $.get(url, (data) => {
        let numItemsData;

        if (numItems) {
            numItemsData = numItems;
        } else {
            numItemsData = $('.minicart-total > .minicart-quantity').html();
        }

        minicart.empty();
        minicart.append(data);
        utils.updateMiniCartSize(0);
        triggerLozad();

        $('.minicart-quantity').empty().append(numItemsData);

        $('.minicart-wrapper .header .back').on('click', () => {
            $('.minicart-wrapper').removeClass('show');
            $('html').css('overflow-y', 'unset');
            overlay.hide();
            triggerLozad();
        });
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    let numPromos = 0;
    const grandTotal = $('#Cart-Show').length ? $('.grand-total') : $('.grand-total-sum');

    $('.number-of-items').empty().append(data.resources.numberOfItems);

    const shippingCostWrapper = $('.shipping-cost');
    const shippingCostParsed = parseFloat(data.totals.totalShippingCost.replace(/[^\d.-]/g, ''));
    const cartShippingAsset = $('.cart-shipping-message-wrapper');
    if (cartShippingAsset.length) {
        shippingCostWrapper.empty().append(cartShippingAsset.html());
    } else {
        shippingCostWrapper.empty().append((shippingCostParsed > 0 || isNaN(shippingCostParsed)) ? data.totals.totalShippingCost : shippingCostWrapper.attr('data-free'));
    }

    $('.tax-total').empty().append(data.totals.totalTax);
    grandTotal.empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);

    updateMiniCartCountClass(data.numItems, $('.minicart-quantity'));

    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems,
    });

    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('d-none');
        $('.order-discount-total').empty()
            .append(`- ${data.totals.orderLevelDiscountTotal.formatted}`);
    } else {
        $('.order-discount').addClass('d-none');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('d-none');
        $('.shipping-discount-total').empty().append(`- ${
            data.totals.shippingLevelDiscountTotal.formatted}`);
    } else {
        $('.shipping-discount').addClass('d-none');
    }

    data.items.forEach((item) => {
        if (item.renderedPromotions) {
            numPromos += 1;

            if ($(`.item-${item.UUID}`).length) {
                $(`.item-${item.UUID}`)
                    .empty()
                    .append(item.renderedPromotions);
            } else {
                updateMiniCart();
            }
        }

        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $(`.item-total-${item.UUID}`).empty().append(item.priceTotal.renderedPrice);
        }

        if (item.quantity) {
            $(`.line-item-price-quantity-${item.UUID}`)
                .empty()
                .append(item.quantity);
        }
    });

    $('.minicart-quantity').empty().append(data.numItems);

    if (numPromos !== $('.bonus-product-line-item').length) {
        updateMiniCart(data.numItems);
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    const errorHtml = `${'<div class="alert alert-danger alert-dismissible valid-cart-error '
        + 'fade show" role="alert">'
        + `<button type="button" class="close no-btn" data-dismiss="alert" aria-label="${utils.getCloseLabel()}">`
        + '<span class="icon-cross-line"></span>'
        + '</button>'}${message}</div>`;

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    let html = '';
    const approachingDiscountsWrapper = $('.approaching-discounts');
    approachingDiscountsWrapper.empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscountsWrapper.removeClass('p-0');
        approachingDiscounts.forEach((item) => {
            html += `<div class="single-approaching-discount text-center">${
                item.discountMsg}</div>`;
        });
    } else {
        approachingDiscountsWrapper.addClass('p-0');
    }
    approachingDiscountsWrapper.append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    let lineItem;
    let messages = '';

    for (let i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    $(`.availability-${lineItem.UUID}`).empty();

    if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach((message) => {
                messages += `<p class="line-item-attributes">${message}</p>`;
            });
        }

        if (lineItem.availability.inStockDate) {
            messages += `<p class="line-item-attributes line-item-instock-date">${
                lineItem.availability.inStockDate
            }</p>`;
        }
    }

    $(`.availability-${lineItem.UUID}`).html(messages);
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean
 *  indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    for (let i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    const lineItem = findItem(data.cartModel.items, item => item.UUID === uuid);
    const $lineItem = $(`.product-info.uuid-${uuid}`);

    if (lineItem.variationAttributes) {
        lineItem.variationAttributes.forEach((val) => {
            const attrSelector = $(`.${val.displayName}-${uuid}`);
            const attrTextValue = `${val.displayName}: ${val.displayValue}`;
            const lineItemSwatch = lineItem.imagesSwatches[val.displayValue];
            const targetAttrValue = $lineItem.find(`span.value[data-attr="${val.id}"]`);
            const imageSwatch = targetAttrValue.find('img.swatch-circle');

            if (attrSelector) {
                $(attrSelector).text(attrTextValue);
            }

            if (imageSwatch && lineItemSwatch) {
                const swatchData = lineItemSwatch.swatch[0];

                $(imageSwatch).attr('src', swatchData.url);
                $(imageSwatch).attr('alt', swatchData.alt);
                $(imageSwatch).attr('title', swatchData.title);
                $(imageSwatch).attr('style', `background-image: url(${swatchData.url})`);
            } else {
                $(targetAttrValue).text(val.displayValue);
            }
        });
    }

    const imageSelector = `.card.product-info.uuid-${uuid} .item-image img`;
    $(imageSelector).attr('src', lineItem.images.small[0].url);
    $(imageSelector).attr('alt', lineItem.images.small[0].alt);
    $(imageSelector).attr('title', lineItem.images.small[0].title);

    if (lineItem.options && lineItem.options.length) {
        const option = lineItem.options[0];
        const optSelector = $lineItem.find(`.line-item-option[data-option-id="${option.optionId}"]`);

        optSelector.attr('data-value-id', option.selectedValueId);
        optSelector.text(option.displayName);
    }

    const qtySelector = `.quantity[data-uuid="${uuid}"]`;
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).attr('data-pid', data.newProductId);

    $(`.remove-product[data-uuid="${uuid}"]`).attr('data-pid', data.newProductId);

    const priceSelector = `.line-item-price-${uuid} .sales .value`;
    $(priceSelector).text(lineItem.price.sales.formatted);
    $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

    if (lineItem.price.list) {
        const listPriceSelector = `.line-item-price-${uuid} .list .value`;
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
    }
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    const htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog big quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + `     <button type="button" class="close no-btn icon-cross-line" data-dismiss="modal" mcclane-data="close-generic-popup" aria-label="${utils.getCloseLabel()}"></button>`
        + '</div>'
        + '<div class="modal-body pb-0 pt-0"></div>'
        + '<div class="modal-footer pr-0"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 * @param {boolean} isGiftCertificate - flag to check if it is a gift certificate
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html, isGiftCertificate) {
    const $html = $('<div>').append($.parseHTML(html));

    let body;
    if (isGiftCertificate) {
        body = $html.find('.product-gift-certificate');
    } else {
        body = $html.find('.product-quickview');
    }
    const footer = $html.find('.modal-footer').children();

    return { body, footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 * @param {boolean} isGiftCertificate - flag to check if it is a gift certificate
 */
function fillModalElement(editProductUrl, isGiftCertificate) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success(data) {
            const parsedHtml = parseHtml(data.renderedTemplate, isGiftCertificate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');

            const { prev, next } = utils.getSliderLabels();
            slickSlider.methods.useCustomizableSlick('.primary-images .gallery-slider', false,
                `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
                `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`, 1, {});
            base.imageZoom(constants);
            triggerLozad();
            $.spinner().stop();
        },
        error() {
            $.spinner().stop();
        },
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    const $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    const $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

function removeDeleteNotAvailableButton() {
    $('.valid-cart-error').find('.close').each((index, buttonClose) => {
        $(buttonClose).on('click', (e) => {
            const buttonRemoveAll = $(e.currentTarget).closest('.cart-error').find('#deleteItemsNotAvailables');
            if (buttonRemoveAll.length) {
                buttonRemoveAll.remove();
            }
        });
    });
}

function deleteNotAvailableProducts() {
    removeDeleteNotAvailableButton();
    $('#deleteItemsNotAvailables').on('click', (e) => {
        $.spinner().start();
        let url = $(e.currentTarget).attr('data-url');
        const type = $(e.currentTarget).attr('data-type');
        const count = $(e.currentTarget).attr('data-numItemsAvailables');
        const params = {
            pids: $(e.currentTarget).attr('data-remove'),
        };
        url = appendToUrl(url, params);
        $.ajax({
            url,
            type: 'post',
            data: params,
            dataType: 'json',
            success(response) {
                if (type === 'cart') {
                    window.location.reload();
                } else {
                    const minicart = $('.minicart-container');
                    minicart.empty();
                    minicart.append(response.renderedTemplate);
                    utils.updateMiniCartSize(500);
                    const miniCartCount = $('.minicart-quantity');
                    // eslint-disable-next-line no-restricted-globals
                    miniCartCount.text(Number.isNaN(count) ? 0 : count);
                    triggerLozad();
                    $.spinner().stop();
                }
            },
            error() {
                $.spinner().stop();
            },
        });
    });
}

module.exports = {
    mehtods: {
        triggerLozad: triggerLozad,
        deleteNotAvailableProducts: deleteNotAvailableProducts,
    },
    toExecute: (function () {
        $('body').on('click', '.remove-product', function (e) {
            e.preventDefault();

            const actionUrl = $(this).data('action');
            const productID = $(this).data('pid');
            const productName = $(this).data('name');
            const uuid = $(this).data('uuid');
            confirmDelete(actionUrl, productID, productName, uuid);
        });

        $('body').on('afterRemoveFromCart', (e, data) => {
            e.preventDefault();
            confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
            $('.cart-delete-confirmation-btn').first().trigger('click');
        });

        $('.optional-promo').click((e) => {
            e.preventDefault();
            $('.promo-code-form').toggle();
        });

        $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
            e.preventDefault();
            const minicart = $('.minicart-container');
            const page = $('.page');
            const html = $('html');
            const productID = $(this).data('pid');
            let url = $(this).data('action');
            const uuid = $(this).data('uuid');
            const urlParams = {
                pid: productID,
                uuid,
            };

            url = appendToUrl(url, urlParams);

            $('body > .modal-backdrop').remove();

            $.spinner().start();
            $.ajax({
                url,
                type: 'get',
                dataType: 'json',
                success(data) {
                    // reload cart to allow finish the checkout in
                    // cart page when you remove a product uncategorized
                    if ($(`.remove-product[data-pid='${productID}']`).closest('.product-card-uncategorized').length) {
                        window.location.reload();
                    }
                    // close minicart to allow finish the checkout from minicart
                    // when you remove a product uncategorized
                    if ($(`.remove-product[data-pid='${productID}']`).closest('.product-line-uncategorized').length) {
                        minicart.removeClass('show');
                        page.removeClass('miniCart-open');
                        html.removeClass('no-overflow');
                        $('.overlay').remove();
                    }
                    if (data.basket.items.length === 0
                        && data.basket.giftCertificateItems.length === 0) {
                        $('.cart').empty().append(`${'<div class="row"> '
                            + '<div class="col-12 empty-minicart text-center"> '
                            + ''}${data.basket.resources.emptyCartMsg} `
                            + '</div> '
                            + '</div>');
                        $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                        $('.minicart-quantity').empty().append(data.basket.numItems);
                        updateMiniCartCountClass(data.numItems, $('.minicart-quantity'));
                        $('.minicart-link').attr({
                            'aria-label': data.basket.resources.minicartCountOfItems,
                            title: data.basket.resources.minicartCountOfItems,
                        });
                        $('.minicart .popover').empty();
                        $('.minicart .popover').removeClass('show');
                        $('body').removeClass('modal-open');
                        $('html').removeClass('veiled');
                    } else {
                        if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                            for (let i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                                $(`.uuid-${data.toBeDeletedUUIDs[i]}`).remove();
                            }
                        }
                        $(`.uuid-${uuid}`).remove();
                        if (!data.basket.hasBonusProduct) {
                            $('.bonus-product').remove();
                        }
                        $('.coupons-and-promos:not(.d-lg-block)').empty().append(data.basket.totals.discountsHtml);
                        updateCartTotals(data.basket);
                        updateApproachingDiscounts(data.basket.approachingDiscounts);
                        $('body').trigger('setShippingMethodSelection', data.basket);
                        validateBasket(data.basket);
                    }

                    $('body').trigger('cart:update', data.basket.totals.grandTotal);

                    $.spinner().stop();
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                },
            });
        });

        $('body').on('change', '.quantity-form > .quantity', function () {
            const preSelectQty = $(this).data('pre-select-qty');
            const quantity = $(this).val();
            const productID = $(this).data('pid');
            let url = $(this).data('action');
            const uuid = $(this).data('uuid');

            const urlParams = {
                pid: productID,
                quantity,
                uuid,
            };
            url = appendToUrl(url, urlParams);

            $(this).parents('.card').spinner().start();

            $.ajax({
                url,
                type: 'get',
                context: this,
                dataType: 'json',
                success(data) {
                    $(`.quantity[data-uuid="${uuid}"]`).val(quantity);
                    $('.coupons-and-promos:not(.d-lg-block)').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    updateAvailability(data, uuid);
                    validateBasket(data);
                    $(this).data('pre-select-qty', quantity);

                    $('body').trigger('cart:update', data.totals.grandTotal);
                    triggerLozad();

                    $.spinner().stop();
                    if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                        window.location.reload();
                    }
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $(this).val(parseInt(preSelectQty, 10));
                        $.spinner().stop();
                    }
                },
            });
        });

        $('.shippingMethods').change(function () {
            const url = $(this).attr('data-actionUrl');
            const urlParams = {
                methodID: $(this).find(':selected').attr('data-shipping-id'),
            };
            // url = appendToUrl(url, urlParams);

            $('.totals').spinner().start();
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: urlParams,
                success(data) {
                    if (data.error) {
                        window.location.href = data.redirectUrl;
                    } else {
                        $('.coupons-and-promos:not(.d-lg-block)').empty().append(data.totals.discountsHtml);
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        validateBasket(data);
                    }
                    $.spinner().stop();
                },
                error(err) {
                    if (err.redirectUrl) {
                        window.location.href = err.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                },
            });
        });

        $('.promo-code-form').submit((e) => {
            e.preventDefault();
            $.spinner().start();
            $('.coupon-missing-error').hide();
            $('.coupon-error-message').empty();
            if (!$('.coupon-code-field').val()) {
                $('.promo-code-form .form-control').addClass('is-invalid');
                $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
                $('.coupon-missing-error').show();
                $.spinner().stop();
                return false;
            }
            const $form = $('.promo-code-form');
            $('.promo-code-form .form-control').removeClass('is-invalid');
            $('.coupon-error-message').empty();

            $.ajax({
                url: $form.attr('action'),
                type: 'GET',
                dataType: 'json',
                data: $form.serialize(),
                success(data) {
                    if (data.error) {
                        $('.promo-code-form .form-control').addClass('is-invalid');
                        $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                        $('.coupon-error-message').empty().append(data.errorMessage);
                        $('body').trigger('promotion:error', data);
                    } else {
                        $('.coupons-and-promos:not(.d-lg-block)').empty().append(data.totals.discountsHtml);
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        validateBasket(data);
                        $('body').trigger('promotion:success', data);
                    }
                    $('.coupon-code-field').val('');
                    $.spinner().stop();
                },
                error(err) {
                    $('body').trigger('promotion:error', err);
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.errorMessage);
                        $.spinner().stop();
                    }
                },
            });
            return false;
        });

        $('body').on('click', '.remove-coupon', function (e) {
            e.preventDefault();

            const couponCode = $(this).data('code');
            const uuid = $(this).data('uuid');
            const $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
            const $productToRemoveSpan = $('.coupon-to-remove');

            $deleteConfirmBtn.data('uuid', uuid);
            $deleteConfirmBtn.data('code', couponCode);

            $productToRemoveSpan.empty().append(couponCode);
        });

        $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
            e.preventDefault();

            let url = $(this).data('action');
            const uuid = $(this).data('uuid');
            const couponCode = $(this).data('code');
            const urlParams = {
                code: couponCode,
                uuid,
            };

            url = appendToUrl(url, urlParams);

            $('body > .modal-backdrop').remove();

            $.spinner().start();
            $.ajax({
                url,
                type: 'get',
                dataType: 'json',
                success(data) {
                    $(`.coupon-uuid-${uuid}`).remove();
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $.spinner().stop();
                    $('body').trigger('promotion:success', data);
                },
                error(err) {
                    $('body').trigger('promotion:error', err);
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                },
            });
        });
        $('body').on('click', '.cart-page .bonus-product-button', function () {
            $.spinner().start();
            $(this).addClass('launched-modal');
            $.ajax({
                url: $(this).data('url'),
                method: 'GET',
                dataType: 'json',
                success(data) {
                    base.methods.editBonusProducts(data);
                    $.spinner().stop();
                },
                error() {
                    $.spinner().stop();
                },
            });
        });

        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', () => {
            $('#chooseBonusProductModal').remove();
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');

            if ($('.cart-page').length) {
                $('.launched-modal .btn-outline-primary').trigger('focus');
                $('.launched-modal').removeClass('launched-modal');
            } else {
                $('.product-detail .add-to-cart').focus();
            }
        });

        $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
            e.preventDefault();

            const editProductUrl = $(this).attr('href');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });

        $('body').on('shown.bs.modal', '#editProductModal', () => {
            $('#editProductModal').siblings().attr('aria-hidden', 'true');
            $('#editProductModal .close').focus();
        });

        $('body').on('hidden.bs.modal', '#editProductModal', () => {
            $('#editProductModal').siblings().attr('aria-hidden', 'false');
        });

        $('body').on('keydown', '#editProductModal', (e) => {
            const focusParams = {
                event: e,
                containerSelector: '#editProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.update-cart-product-global',
                nextToLastElementSelector: '.modal-footer .quantity-select',
            };
            focusHelper.setTabNextFocus(focusParams);
        });

        $('body').on('product:updateAddToCart', (e, response) => {
            // update global add to cart (single products, bundles)
            const dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.update-cart-product-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available'));
        });

        $('body').on('product:updateAvailability', (e, response) => {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);


            const dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                const allAvailable = $('.product-availability', dialog).toArray()
                    .every(item => $(item).data('available'));

                const allReady = $('.product-availability', dialog).toArray()
                    .every(item => $(item).data('ready-to-order'));

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });

        $('body').on('product:afterAttributeSelect', (e, response) => {
            const productDataId = response.data.product.id;

            if ($('.modal.show .product-quickview .bundle-items').length) {
                $('.modal.show').find(response.container).attr('data-pid', productDataId);
                $('.modal.show').find(response.container).find('.product-id').text(productDataId);
            } else {
                const selectedOption = response.data.product.options.length
                    ? response.data.product.options[0].selectedValueId : productDataId;

                $('.modal.show .product-quickview').attr('data-pid', productDataId);
                $('.modal.show .update-cart-url').attr('data-selected-option', selectedOption);
            }

            // condition only for click variant before full JS charge,
            // check if event 'product:afterAttributeSelect' is available
            if ($('.product-id').length) {
                const product = response.data.variationInfo && response.data.variationInfo
                    ? response.data.variationInfo
                    : response.data.product;
                const productID = product && product.variationId
                    ? product.variationId
                    : product.id;

                response.container.find('.product-id').text(productID);
                response.container.attr('data-pid', productID);
            }
        });

        $('body').on('change', '.quantity-select', function () {
            const selectedQuantity = $(this).val();
            $('.modal.show .update-cart-url').attr('data-selected-quantity', selectedQuantity);
        });

        $('body').on('change', '.options-select', function () {
            const selectedOptionValueId = $(this).children('option:selected').data('value-id');
            $('.modal.show .update-cart-url').attr('data-selected-option', selectedOptionValueId);
        });

        $('body').on('click', '.update-cart-product-global', function (e) {
            e.preventDefault();

            const updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
            const selectedQuantity = parseInt($(e.currentTarget).closest('.modal-footer').find('.quantity-form  .quantity').val(), 10);
            const selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').attr('data-selected-option');
            const uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').attr('data-uuid');

            const form = {
                uuid,
                pid: base.getPidValue($(this)),
                quantity: selectedQuantity,
                selectedOptionValueId,
            };

            $(this).parents('.card').spinner().start();
            if (updateProductUrl) {
                $.ajax({
                    url: updateProductUrl,
                    type: 'post',
                    context: this,
                    data: form,
                    dataType: 'json',
                    success(data) {
                        $('#editProductModal').modal('hide');

                        $('.coupons-and-promos:not(.d-lg-block)').empty().append(data.cartModel.totals.discountsHtml);
                        updateCartTotals(data.cartModel);
                        updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                        updateAvailability(data.cartModel, uuid);
                        updateProductDetails(data, uuid);

                        if (data.uuidToBeDeleted) {
                            $(`.uuid-${data.uuidToBeDeleted}`).remove();
                        }

                        validateBasket(data.cartModel);

                        $('body').trigger('cart:update');

                        $.spinner().stop();
                    },
                    error(err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification(err.responseJSON.errorMessage);
                            $.spinner().stop();
                        }
                    },
                });
            }
        });

		$(document.body).on('click', '.promo-code-toggle', (e) => {
			const thisTarget = $(e.currentTarget);
			const expanded = thisTarget.attr('aria-expanded') === 'true';
			thisTarget.attr('aria-expanded', String(!expanded));
			thisTarget.toggleClass('active');
			$('#couponFormRow').slideToggle().css('display', 'flex');
		});

        $(document.body).on('click', '.cart-bundle-wrapper .bundle-includes', (e) => {
            const thisTarget = $(e.currentTarget);
            thisTarget.toggleClass('active');
            thisTarget.find('.icon-down-arrow-line').toggleClass('open');
            thisTarget.siblings('.bundle-items-wrapper').slideToggle();
        });

        // handling edit gift certificate click
        $('body').on('click', '.cart-page .gift-card-edit .edit', function (e) {
            e.preventDefault();

            const editProductUrl = $(this).attr('href');
            getModalHtmlElement();
            fillModalElement(editProductUrl, true);
        });

        $(document.body).on('click', '.store-hours', (e) => {
            const thisTarget = $(e.currentTarget).find('.open-hours');
            thisTarget.toggleClass('active');
            thisTarget
                .siblings('.hours-container')
                .slideToggle();
        });


        $('#deleteItemsNotAvailables').on('click', (e) => {
            $.spinner().start();
            let url = $(e.currentTarget).attr('data-url');
            const type = $(e.currentTarget).attr('data-type');
            const params = {
                pids: $(e.currentTarget).attr('data-remove'),
            };
            url = appendToUrl(url, params);
            $.ajax({
                url,
                type: 'post',
                data: params,
                dataType: 'json',
                success(data) {
                    if (type === 'cart') {
                        window.location.reload();
                    } else {
                        const minicart = $('.minicart-container');
                        minicart.empty();
                        minicart.append(data.renderedTemplate);
                        utils.updateMiniCartSize(500);
                        triggerLozad();
                    }
                },
                error() {
                    $.spinner().stop();
                },
            });
        });
        removeDeleteNotAvailableButton();

        base.selectAttribute();
        base.colorAttribute();
        base.removeBonusProduct();
        base.selectBonusProduct();
        base.enableBonusProductSelection();
        base.showMoreBonusProducts();
        base.addBonusProductsToCart();
        base.focusChooseBonusProductModal();
        base.trapChooseBonusProductModalFocus();
        base.onClosingChooseBonusProductModal();
        base.availability();
        base.addToCart();
        base.addToCartGrid('body');
    }()),
};
